import {
    // Reducers statiques :
    RoutingReducer,

    // Tiers :
    ConfigurationParameters,
    Configuration,
    TIERS_REDUCER_NAME,
    PAYS_SLICE_NAME,
    WALLET_OPTIONS_SLICE_NAME,
    CIVILITIES_SLICE_NAME,
    CSP_OPTIONS_SLICE_NAME,

    // Mail :
    ConfigurationParameters as MailConfigurationParameters,
    APIENV,

    // Formalités :
    APIS_ENUM,

    // Others ...
    SIGNATURE_REDUCER_NAME,
    MailApi,
    getCustomiserState,
    getApiConfiguration,
    UtilisateurApi,
} from '@europrocurement/l2d-domain';

import { CUSTOMIZER_REDUCER_NAME, CustomizerReducer } from '@europrocurement/l2d-modules';

import {
    CategorieSocioProfessionnelleJsonldTiersRead,
    PortefeuilleJsonldTiersRead,
    TblParametreReferencesCiviliteJsonldCiviliteReadCollection,
    TblPaysJsonldPaysRead,
} from '@europrocurement/l2d-domain/openApi/ApiTiers';

import { FactureFormReducer } from './FactureFormReducer';

// Keycloak token
import { updateToken } from '../keycloak';

import { combinedDossierSignatureReducer } from './subReducers/DossierSignature/Reducer';

import { type RootStateType } from './types';

export { customizerSelector } from '@europrocurement/l2d-modules';

const configUtilisateurs: ConfigurationParameters = getApiConfiguration(
    APIS_ENUM.UTILISATEUR,
    updateToken,
);
const configFacturation: ConfigurationParameters = getApiConfiguration(
    APIS_ENUM.FACTURATION,
    updateToken,
);

export const utilisateurApi = new UtilisateurApi(new Configuration(configUtilisateurs));

/**
 * Mail
 */
const configMail: MailConfigurationParameters = {
    basePath: APIENV.apis.mail[getCustomiserState().api.mail],
    accessToken: updateToken,
};

export const mailConfiguration = new Configuration(configMail);

export const mailApi = new MailApi(mailConfiguration);

// Generate Redux Store Structure
export const standaloneReducerBase = {
    [CUSTOMIZER_REDUCER_NAME]: CustomizerReducer,
    factureForm: FactureFormReducer,

    [SIGNATURE_REDUCER_NAME]: combinedDossierSignatureReducer,
    routing: RoutingReducer,
};

/**
 * FactureForm
 */
export const FactureFormSelector = (s: RootStateType) => s.factureForm;

export const RoutingSelector = (s: RootStateType) => s.routing.routing;

/**
 * Tiers
 */

type OptionsStore = (store: RootStateType) => {
    countries: TblPaysJsonldPaysRead[];
    cspOptions: CategorieSocioProfessionnelleJsonldTiersRead[];
    walletOptions: PortefeuilleJsonldTiersRead[];
    civilities: TblParametreReferencesCiviliteJsonldCiviliteReadCollection[];
};

export const OptionsSelector: OptionsStore = (store: RootStateType) => ({
    countries: store[TIERS_REDUCER_NAME][PAYS_SLICE_NAME].main.data,
    cspOptions: store[TIERS_REDUCER_NAME][CSP_OPTIONS_SLICE_NAME].main.data,
    walletOptions: store[TIERS_REDUCER_NAME][WALLET_OPTIONS_SLICE_NAME].main.data,
    civilities: store[TIERS_REDUCER_NAME][CIVILITIES_SLICE_NAME].main.data,
});
export const OptionsLoaded = (store: RootStateType) => {
    type OptionSlice =
        | typeof PAYS_SLICE_NAME
        | typeof CSP_OPTIONS_SLICE_NAME
        | typeof WALLET_OPTIONS_SLICE_NAME
        | typeof CIVILITIES_SLICE_NAME;

    const optionSlicesNames = [
        PAYS_SLICE_NAME,
        CSP_OPTIONS_SLICE_NAME,
        WALLET_OPTIONS_SLICE_NAME,
        CIVILITIES_SLICE_NAME,
    ];

    // eslint-disable-next-line consistent-return
    optionSlicesNames.forEach((sliceName: OptionSlice) => {
        const sliceStatus = store[TIERS_REDUCER_NAME][sliceName].main.status;
        if (sliceStatus !== 'succeeded') {
            return false;
        }
    });

    return true;
};

/**
 * Dossiers
 */

/**
 * Facturation
 */
export const facturationConfiguration = new Configuration(configFacturation);
